import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableBody, TableRow, TableCell, Box, Tooltip } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { formatDate } from '../../../../utils/formatDate';
import { getRouteWithParam, ROUTES } from '../../../../constants/routes';
import { More } from '../More';
import { getMailingCampaignType, getMailingColorStatus, getMailingStatus, getMailingType } from '../../constants';
import { DISABLED_CONTROL_TOOLTIP } from '../../../../constants/variables';

export const TemplatesTableBody = ({ data, setCurID, setIsSuccessModal, isViewableItems, isEditableItem, isBackToWorkItem, isDeletableItem }) => {
  const history = useHistory();
  const [tooltip, setTooltip] = useState(false);

  const tableRow = (component, key) => tooltip ?
    <Tooltip key={key} title={DISABLED_CONTROL_TOOLTIP} arrow data-testid="Tooltip">{component}</Tooltip> :
    component;

  const gotoTemplateDetailEvent = (templateId) => {
    history.push(getRouteWithParam(ROUTES.MAILING_DETAIL_TEMPLATE, ':id', templateId));
  }

  return (
    <TableBody data-testid="TableBody">
      {data?.map((template) => tableRow(
        <TableRow
          key={template.id}
          onClick={() => isViewableItems ? gotoTemplateDetailEvent(template.id) : setTooltip(true)}
          onMouseLeave={() => setTooltip(false)}
          sx={{ cursor: isViewableItems ? 'pointer' : 'default' }}
          data-testid="TableRow"
        >
          <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            <Box width="100px">{template?.id}</Box>
          </TableCell>

          <TableCell>
            <Box width="180px">{template.name}</Box>
          </TableCell>

          <TableCell>
            <Box>{formatDate(template.created_at, 'true')}</Box>
          </TableCell>

          <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            <Box width="150px">{getMailingCampaignType(template?.campaign_type)}</Box>
          </TableCell>

          <TableCell sx={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
            <Box width="150px">{getMailingType(template?.mailing_type)}</Box>
          </TableCell>

          <TableCell>
            <Box color={`${getMailingColorStatus(template.status)}`} data-testid={`status ${template.status}`}>
              {getMailingStatus(template.status)}
            </Box>
          </TableCell>

          <TableCell onClick={(e) => e.stopPropagation()}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <More
                id={template.id}
                status={template.status}
                setCurID={setCurID}
                setIsSuccessModal={setIsSuccessModal}
                isEditableItem={template.status === 'created' ? isEditableItem : true}
                isBackToWorkItem={isBackToWorkItem}
                isDeletableItem={isDeletableItem}
              />
            </Box>
          </TableCell>
        </TableRow>
      ))}
    </TableBody>
  );
};

TemplatesTableBody.propTypes = {
  data: PropTypes.array,
  setCurID: PropTypes.func,
  setIsSuccessModal: PropTypes.func,
  isViewableItems: PropTypes.bool,
  isEditableItem: PropTypes.bool,
  isBackToWorkItem: PropTypes.bool,
  isDeletableItem: PropTypes.bool,
};
